/**
 * User-facing strings for spreadsheet import (ClickUp 86e3ey4dn, 86e3exdv2).
 * The upload step, both import dialogs, the Data entry launcher, the command
 * palette entry and the tests all read from here, so wording changes once.
 */

// --- File acceptance -------------------------------------------------------

/** The `accept` attribute for the file picker. */
export const IMPORT_FILE_ACCEPT = '.csv,.xlsx'
export const FILE_PICKER_LABEL = 'Select CSV or Excel file'
export const UNSUPPORTED_FILE = 'Only CSV and Excel (.xlsx) files are supported.'
export const LEGACY_XLS_FILE =
  'Older Excel files (.xls) are not supported. Save it as an Excel Workbook (.xlsx) or CSV, then upload that.'
export const MACRO_FILE =
  'Macro-enabled workbooks are not supported. Save it as an Excel Workbook (.xlsx) or CSV, then upload that.'
export const EMPTY_FILE = 'File is empty. Please choose a file with data in it.'
/** @param {number} maxMb */
export const fileTooLarge = (maxMb) => `File is too large. Maximum size is ${maxMb}MB.`
/** @param {number} maxMb */
export const fileLimitsHint = (maxMb) => `CSV or Excel (.xlsx), up to ${maxMb}MB`
export const DROP_HERE = 'Drop your file here'
export const DRAG_AND_DROP = 'Drag and drop a CSV or Excel file here'
export const READING_FILE = 'Reading your file…'
/** @param {string} sheetName */
export const sheetNameNote = (sheetName) => `Reading the first sheet: ${sheetName}`

// --- Metric import dialog --------------------------------------------------

export const METRIC_IMPORT_TITLE = 'Import spreadsheet'
/** @param {string} metricName */
export const metricImportDescription = (metricName) =>
  `Import data into ${metricName} from a CSV or Excel (.xlsx) file`
export const NO_HEADERS = 'The file has no column headers in its first row.'
export const XLSX_DATE_HINT =
  'Excel date cells are read as dates automatically; the format only applies to dates typed as text.'

// --- Partition value import dialog -----------------------------------------

export const PARTITION_IMPORT_TITLE = 'Import spreadsheet'

// --- Data entry launcher (86e3exdv2) ---------------------------------------

export const IMPORT_SPREADSHEET_BUTTON = 'Import spreadsheet'
export const PICK_METRIC_TITLE = 'Import into which metric?'
export const PICK_METRIC_DESCRIPTION =
  'Choose the metric the spreadsheet’s values belong to. Next you’ll upload the file and match its columns.'
export const PICK_METRIC_CONFIRM = 'Continue'
export const METRIC_LOAD_FAILED = 'Could not load that metric. Please try again.'

// --- Command palette -------------------------------------------------------

export const PALETTE_IMPORT_NAME = 'Import spreadsheet'
export const PALETTE_IMPORT_DESCRIPTION = 'Upload a CSV or Excel file into a metric'
/** Data entry opens the import flow when it sees this query parameter. */
export const IMPORT_QUERY_PARAM = 'import'
export const IMPORT_SPREADSHEET_PATH = `/data-entry?${IMPORT_QUERY_PARAM}=1`
